import _isEmpty from 'lodash/isEmpty';

import pageApi from './api';
import * as types from './actionTypes';

function fetchPageStart(alias) {
  return {
    type: types.FETCH_PAGE_REQUEST,
    payload: { alias },
  };
}

function fetchPageDone(alias, data) {
  return {
    type: types.FETCH_PAGE_SUCCESS,
    payload: { alias, data },
  };
}

function fetchPageFail(alias, error) {
  return {
    type: types.FETCH_PAGE_FAILURE,
    payload: { alias, error },
  };
}

export const fetchPage = params => {
  return dispatch => {
    const { alias } = params;

    dispatch(fetchPageStart(alias));

    return pageApi
      .getPage(params)
      .then(data => {
        return dispatch(fetchPageDone(alias, data));
      })
      .catch(({ message }) => {
        return dispatch(fetchPageFail(alias, message));
      });
  };
};

export const fetchPageIsNeeded = params => {
  return (dispatch, getState) => {
    const { alias } = params;

    if (_isEmpty(getState().page.list[alias])) {
      return dispatch(fetchPage(params));
    }

    return null;
  };
};

function fetchCompositeDetailStart(alias) {
  return {
    type: types.FETCH_COMPOSITE_DETAIL_REQUEST,
    payload: { alias },
  };
}

function fetchCompositeDetailDone(alias, data) {
  return {
    type: types.FETCH_COMPOSITE_DETAIL_SUCCESS,
    payload: { alias, data },
  };
}

function fetchCompositeDetailFail(alias, error) {
  return {
    type: types.FETCH_COMPOSITE_DETAIL_FAILURE,
    payload: { alias, error },
  };
}

export const fetchCompositeDetail = params => {
  return dispatch => {
    const { alias } = params;

    dispatch(fetchCompositeDetailStart(alias));

    return pageApi
      .getPageCompositeDetail(params)
      .then(data => {
        return dispatch(fetchCompositeDetailDone(alias, data));
      })
      .catch(({ message }) => {
        return dispatch(fetchCompositeDetailFail(alias, message));
      });
  };
};

export const fetchCompositeDetailIsNeeded = params => {
  return (dispatch, getState) => {
    const { alias } = params;

    if (_isEmpty(getState().page.list[alias])) {
      return dispatch(fetchCompositeDetail({ alias }));
    }

    return null;
  };
};
